import React from 'react';

import StatusBox from 'components/StatusBox';

const PASSED = 'passed';
const PENDING = 'pending';

const AFFORDABILITY_STATUSES_COLORS = {
  [PASSED]: StatusBox.GREEN,
  [PENDING]: StatusBox.ORANGE
};

interface AffordabilityStatusBoxProps {
  affordabilityPassed: boolean;
}

class AffordabilityStatusBox extends React.Component<
  AffordabilityStatusBoxProps
> {
  render() {
    const {affordabilityPassed} = this.props;

    const status = affordabilityPassed ? PASSED : PENDING;

    return (
      <StatusBox
        color={AFFORDABILITY_STATUSES_COLORS[status]}
        status={status}
      />
    );
  }
}

export default AffordabilityStatusBox;
